import React from "react";
import { Input, Stack, Text, Textarea } from "@chakra-ui/react";
import { walletTextFieldSx } from "../artistWallet/dialogStyles";
import { TierSelect, CurrencySelect } from "./CreateFormFields";

/**
 * Returns the initial state for the paid creation form.
 * @returns {Object}
 */
export function buildPaidInitialState() {
    return { subscription_type: "violet", currency: "EUR", amount: "", reason: "" };
}

/**
 * Builds the API payload for POST /create-paid.
 * Sends amount as null when left empty so the backend uses its default price.
 * @param {Object} form - Paid form state
 * @param {number} userId - Target user ID
 * @returns {Object} Payload ready for the API
 */
export function buildPaidPayload(form, userId) {
    const trimmed = String(form.amount).trim();
    const parsed = trimmed === "" ? null : Number(trimmed);
    return {
        owner_type: "user",
        owner_id: userId,
        subscription_type: form.subscription_type,
        currency: form.currency,
        amount: parsed,
        reason: form.reason.trim() || undefined,
    };
}

/**
 * Validates the paid form state. Returns null if valid, an error message otherwise.
 * @param {Object} form - Paid form state
 * @returns {string|null}
 */
export function validatePaidForm(form) {
    if (!form.subscription_type) return "Sélectionne un type d'abonnement";
    if (!form.currency) return "Sélectionne une devise";
    const trimmed = String(form.amount).trim();
    if (trimmed !== "") {
        const parsed = Number(trimmed);
        if (Number.isNaN(parsed) || parsed < 0) return "Le montant doit être un nombre positif";
    }
    return null;
}

/**
 * Paid subscription creation form. Controlled by parent state.
 * Amount field is optional (empty = backend default).
 * @param {Object} props
 * @param {Object} props.form - Form state object
 * @param {Function} props.setForm - State setter (receives the updated form)
 * @returns {React.ReactElement}
 */
function CreatePaidForm({ form, setForm }) {
    const update = (key, value) => setForm({ ...form, [key]: value });
    return (
        <Stack spacing={4}>
            <Text color="rgba(255, 255, 255, 0.7)" fontSize="0.85rem">
                Crée un abonnement payant : un SetupIntent Stripe est généré et un lien sécurisé est renvoyé. À transmettre à l'utilisateur pour qu'il saisisse sa carte. L'abonnement reste en attente jusqu'à validation.
            </Text>
            <TierSelect value={form.subscription_type} onChange={(v) => update("subscription_type", v)} />
            <CurrencySelect value={form.currency} onChange={(v) => update("currency", v)} />
            <Input placeholder="Montant (optionnel — vide = prix par défaut)" type="number"
                min={0} step="0.01"
                value={form.amount} onChange={(e) => update("amount", e.target.value)} {...walletTextFieldSx} />
            <Textarea rows={2} placeholder="Raison (optionnelle)"
                value={form.reason} onChange={(e) => update("reason", e.target.value)} {...walletTextFieldSx} />
        </Stack>
    );
}

export default CreatePaidForm;
